import styled from 'styled-components';

import Icon from './icon';
import checkedStyle from './checked-style';

export default styled.input.attrs(() => ({
  type: 'checkbox',
}))`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
  &:checked ~ ${Icon} {
    ${checkedStyle}
  }
`;
